import { Button, CircularProgress } from '@material-ui/core'
import { Theme, makeStyles } from '@material-ui/core/styles'
import React, { useCallback, useState } from 'react'

const useAddToProjectButtonStyles = makeStyles((theme: Theme) => ({
    container: {
        position: 'relative',
    },
    loadingIcon: {
        position: 'absolute',
        left: 0,
        color: '#FFFFFF',
    },
}))
interface NewWorkspaceAddRemoveButtonProps {
    isDisabled: boolean
    isLoading: boolean
    label: string
    className: string
    onClick: (_: React.MouseEvent<Element, MouseEvent>) => void
    dataTestId: string
}
export const NewWorkspaceAddRemoveButton = ({
    isDisabled,
    isLoading,
    label,
    className,
    onClick,
    dataTestId,
}: NewWorkspaceAddRemoveButtonProps) => {
    const classes = useAddToProjectButtonStyles()
    const [buttonRect, setButtonRect] = useState<DOMRect | null>(null)

    const buttonRef = useCallback((node: HTMLButtonElement | null) => {
        if (node) {
            setButtonRect(node.getBoundingClientRect())
        }
    }, [])
    return (
        <div className={classes.container}>
            <Button
                ref={buttonRef}
                disabled={isDisabled}
                className={className}
                data-testid={dataTestId}
                variant="outlined"
                onClick={onClick}
                role="button"
            >
                {label}
            </Button>
            {isLoading && (
                <CircularProgress
                    size={14}
                    className={classes.loadingIcon}
                    style={{
                        marginLeft: buttonRect
                            ? (buttonRect.width - 14) / 2
                            : 0,
                        marginTop: buttonRect
                            ? (buttonRect.height - 14) / 2
                            : 0,
                    }}
                />
            )}
        </div>
    )
}
